import React from 'react';
import { Icon } from '@blueprintjs/core';

// Numbered progress stepper for the booking modal. Display only: the modal
// moves between steps with Back / Continue, never by jumping.
const BookingStepper = ({ steps, current }) => {
  const total = steps.length;
  const position = Math.min(Math.max((current || 1) - 1, 0), total - 1);
  const progress = total > 1 ? (position / (total - 1)) * 100 : 0;

  return (
    <nav className="bk-stepper" aria-label="Booking progress" style={{ '--bk-steps': String(total) }}>
      <div className="bk-stepper__track" aria-hidden="true">
        <span className="bk-stepper__fill" style={{ width: `${progress}%` }} />
      </div>
      <ol className="bk-stepper__list">
        {steps.map((label, index) => {
          const number = index + 1;
          const state = number < current ? 'done' : number === current ? 'current' : 'upcoming';
          return (
            <li
              key={label}
              className={`bk-stepper__step is-${state}`}
              aria-current={state === 'current' ? 'step' : undefined}
            >
              <span className="bk-stepper__dot">
                {state === 'done' ? <Icon icon="tick" iconSize={12} /> : number}
              </span>
              <span className="bk-stepper__label">
                {label}
                {state === 'done' && <span className="bk-sr-only"> (completed)</span>}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BookingStepper;
